module.exports = __webpack_public_path__ + "static/img/voroStand3.f367ab8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/makeVoroStand/imgs/voroStand3.jpg
// module id = H2Go
// module chunks = 2